import { fetcher } from '@commenda/utils';

export async function renewQuote(
  // Affiliate firm to create a quote for:
  affiliateFirmId: string,
  quoteId: string
): Promise<Response | null> {
  try {
    const res = await fetcher(
      `affiliate-firms/${affiliateFirmId}/quotes/${quoteId}/renewQuote`,
      {
        method: 'PUT',
      }
    );

    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}
